import { Api } from '../Common/rest-api/api-exports';

export const getListOfPatientsFilter = (data = {}) =>
    Api.Patients.listFilter(data)
        .then(res => res.body)
        .catch(error => error);

export const getSinglePatient = id =>
    Api.Patients.single(id)
        .then(res => res.body)
        .catch(err => err);

export const createPatient = details => {
    return Api.Patients.add({
        name: details.username,
        phone: details.phone,
        pharmacy: details.pharmacy,
        email: details.email,
        dateOfBirth: details.birthdayValue,
        address: {
            name: details.address.name,
            latitude: details.address.latitude,
            longitude: details.address.longitude
        },
        insuranceCards: {
            primaryCardNumber: details.insuranceCard,
            secondaryCardNumber: details.secondInsuranceCard,
            // primaryCardImageURL: details.has_primaryCardImageURL ? details.primaryCardImageURL : '',
            // primaryCardBackImageURL: details.has_primaryCardBackImageURL ? details.primaryCardBackImageURL : '',
            // secondaryCardImageURL: details.has_secondaryCardImageURL ? details.secondaryCardImageURL : '',
            // secondaryCardBackImageURL: details.has_secondaryCardBackImageURL ? details.secondaryCardBackImageURL : ''
        }
    });
};

export const editPatient = (id, details) => {
    return Api.Patients.edit(id, {
        name: details.username,
        phone: details.phone,
        pharmacy: details.pharmacyId,
        email: details.email,
        dateOfBirth: details.birthdayValue,
        address: {
            name: details.address.name,
            latitude: details.address.latitude,
            longitude: details.address.longitude
        },
        insuranceCards: {
            primaryCardNumber: details.insuranceCard,
            secondaryCardNumber: details.secondInsuranceCard,
            // primaryCardImageURL: details.has_primaryCardImageURL ? details.primaryCardImageURL : '',
            // primaryCardBackImageURL: details.has_primaryCardBackImageURL ? details.primaryCardBackImageURL : '',
            // secondaryCardImageURL: details.has_secondaryCardImageURL ? details.secondaryCardImageURL : '',
            // secondaryCardBackImageURL: details.has_secondaryCardBackImageURL ? details.secondaryCardBackImageURL : ''
        }
    });
};

export const deletePatient = id => {
    return Api.Patients.delete(id);
};

export const resendPasswordForPatient = (id, details) => {
    return Api.Patients.resendPassword(id, { id: details });
};



// WEBPACK FOOTER //
// ./src/customModules/Patients/epics-patients.js